import { Badge, Button, Grid, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconHelp, IconMessage, IconPhone, IconShieldLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { ClientPortalLayout } from './components/ClientPortalLayout';
import { mockCareTeam } from './data/mockClientPortalData';

export function ClientPortalDirectoryPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <ClientPortalLayout
      title="Directory"
      description="Contact your care team and find help resources. This section is intentionally simple for a first cut."
    >
      <Grid>
        <Grid.Col span={{ base: 12, md: 7 }}>
          <Paper p="lg" withBorder>
            <Group justify="space-between" mb="md">
              <Title order={3}>Your care team</Title>
              <Badge variant="light" color="blue">
                Secure
              </Badge>
            </Group>

            <Stack gap="md">
              {mockCareTeam.map((c) => (
                <Paper key={c.id} p="md" withBorder>
                  <Group justify="space-between" align="flex-start">
                    <div>
                      <Text size="sm" fw={600}>
                        {c.name}
                      </Text>
                      <Text size="xs" c="gray.6">
                        {c.role}
                      </Text>
                      <Text size="sm" c="gray.6" mt={6}>
                        {c.details}
                      </Text>
                    </div>
                    <Button
                      size="xs"
                      leftSection={<IconMessage size={14} />}
                      onClick={() => navigate('/client-portal/messages')}
                    >
                      Message
                    </Button>
                  </Group>
                </Paper>
              ))}
            </Stack>
          </Paper>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 5 }}>
          <Stack gap="lg">
            <Paper p="lg" withBorder>
              <Group gap="xs" mb="sm">
                <IconShieldLock size={18} stroke={1.5} />
                <Title order={4}>Privacy & security</Title>
              </Group>
              <Text size="sm" c="gray.6">
                Avoid sharing sensitive details in public places. Use portal messaging for secure communication.
              </Text>
            </Paper>

            <Paper p="lg" withBorder>
              <Group gap="xs" mb="sm">
                <IconHelp size={18} stroke={1.5} />
                <Title order={4}>Need help?</Title>
              </Group>
              <Text size="sm" c="gray.6" mb="md">
                If you have questions about appointments, forms, or billing, send a secure message in the portal.
              </Text>
              <Button variant="light" leftSection={<IconMessage size={16} />} onClick={() => navigate('/client-portal/messages')}>
                Message support
              </Button>
            </Paper>

            <Paper p="lg" withBorder>
              <Group gap="xs" mb="sm">
                <IconPhone size={18} stroke={1.5} />
                <Title order={4}>In crisis?</Title>
              </Group>
              <Text size="sm" c="gray.6">
                If you or someone you know is in immediate danger, call your local emergency number. In the US, you can
                also call or text <Text span fw={600}>988</Text> for the Suicide & Crisis Lifeline.
              </Text>
            </Paper>
          </Stack>
        </Grid.Col>
      </Grid>
    </ClientPortalLayout>
  );
}

